import { useState, useEffect } from 'react'
import { useAuth } from '../firebase/firebase';
import { useNavigate } from 'react-router-dom';
import { ACCOUNT_LOADING } from '../firebase/firebase';
import PermissionDenied from '../ErrorPages/PermissionDenied';

const LOADING = 0;
const PERMISSION_DENIED = -1;
const PERMISSION_GRANTED = 1;

var PrivateRoute = ({ children, requiredPermission, path}) => {
    let navigate = useNavigate();
    const [account, accountData] = useAuth();
    const [state, setState] = useState(LOADING);

    useEffect(() => {
        if (account !== ACCOUNT_LOADING && accountData !== ACCOUNT_LOADING) {
            if (account == null && accountData == null)
                navigate('/signin', {state: path});
            else if (accountData != null)
                setState(accountData.permissions.includes(requiredPermission) ? PERMISSION_GRANTED : PERMISSION_DENIED);
        }
    }, [account, accountData, navigate, path, requiredPermission]);

    if (state === PERMISSION_GRANTED)
        return children;
    else if (state === LOADING)
        return;
    else if (state === PERMISSION_DENIED)
        return <PermissionDenied path={path} accountData={accountData}/>
};

export default PrivateRoute;